import Group from './index'
import timestamp from 'utils/firebaseTimestamp'

const GroupConverter = {
  toFirestore: (group) => {
    const { id, name, description, ...fs } = group

    return {
      ...fs,
      search: `${name.toLowerCase()} ${description?.toLowerCase()}`,
      name,
      description,
      ...timestamp(id),
    }
  },
  fromFirestore: (snapshot, options) => {
    const group = snapshot.data(options)
    return new Group(
      group.name,
      group.description,
      group.photo,
      group.isPrivate,
      group.deletedAt?.toDate(),
      snapshot.id
    )
  },
}

export default GroupConverter
